/* globals Store, Router */

import tapApi from '@/utils/api/tap-api'
import ssoApi from '@/utils/api/sso-api'
import {User, Dashboard, Kyc} from '@/models'
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice
} from '@/utils/store-util.js'
const state = {
  callingAPI: false,
  searching: '',
  user: new User(),
  token: '',
  completion: 0,
  dashboard: new Dashboard(),
  profilePictureSrc: '',
  kyc: {
    pan: new Kyc('PAN'),
    aadhar: new Kyc('AADHAR')
  },
  profilePic: null,
  loading: false
}

const actions = {
  forgotpassword ({ commit }, user) {
    ssoApi.postData('forgot-password/for/tap', user)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        Store.dispatch('project/manageAlertBox',
          {
            status: true,
            text: 'Password reset link sent to your EmailId. Please update the password and login again. <br> Note: The link is valid for 30 mins'
          })
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(null, 'Operation failed! Please try again later. ')
      closeNotice(null, 20000)
    })
  },
  signup ({ commit }, user) {
    ssoApi.postData('boot/signup/tap', user)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        Store.dispatch('project/manageAlertBox',
          {
            status: true,
            text: 'THANK YOU for signing-up with Ordertrainings.com. Verification link has been sent to your EmailId. Please verify your Email and Login Again! <br>Note: The link is valid for 24 hrs'
          })
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(null, 'Operation failed! Please try again later. ')
      closeNotice(null, 20000)
    })
  },
  changePassword ({ commit }, password) {
    ssoApi.postData('user/change-password', password)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        Store.dispatch('project/manageAlertBox',
          {
            status: true,
            text: 'Password Changed Successfully! Please login again with new Password'
          })
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Change Password feature failed! Please try again later.')
      closeNotice(commit, 20000)
    })
  },
  saveUser ({ commit }, user) {
    // edit case
    ssoApi.putData('user/update', user)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setUser', res.data.data[0])
        Store.dispatch('user/viewProfilePicture')
        // sendSuccessNotice(commit, 'Education Information has been updated.')
        // closeNotice(commit, 1500)
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
    })
  },
  uploadProfilePic ({ commit }, {data, cb}) {
    if (data === null) {
      sendErrorNotice(null, 'No file selected to save')
      closeNotice(commit, 20000)
    } else {
      commit('setLoading', true)
      let formData = new FormData()
      formData.append('file', data)
      tapApi.uploadData('user/uploadToS3/profile_images', formData)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          let user = { ...Store.state.user.user }
          user.profilePicture = res.data.data[0]
          Store.dispatch('user/saveUser', user)
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Profile Pic Upload Failed! Please try again later.')
        closeNotice(commit, 20000)
      })
      .finally(() => {
        commit('setLoading', false)
        if (cb) cb()
      })
    }
  },
  viewProfilePicture ({ commit }) {
    const url = Store.state.user.user.profilePicture
    if (url === null || url === '') return
    tapApi.downloadData('user/downloadFromS3?url=' + url)
    .then(res => {
      const imgSrc = window.URL.createObjectURL(new Blob([res.data]))
      commit('setProfilePictureSrc', imgSrc)
    })
    .catch(err => {
      console.log('error ocuured in profile pic download')
      console.log(err)
      sendErrorNotice(commit, 'Profile Picture View Failed! Please try again later.')
      closeNotice(commit, 20000)
    })
  },
  recommendToFriend ({ commit }, {email, cb}) {
    commit('setLoading', true)
    tapApi.postData('user/recommend-to-friend', { email: email })
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        sendSuccessNotice(null, 'Thankyou for reccomending your friend')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log('error in RecommendToFriend')
      console.log(err)
      sendErrorNotice(null, 'Reccomend to Friend feature failed')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  updateUser ({ commit }, { user, token }) {
    commit('setToken', token)
    commit('setUser', user)
    Store.dispatch('user/viewProfilePicture')
  },
  updateCompletion ({ commit }, cb) {
    tapApi.getData('algo/profile_completion')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setCompletion', res.data.data[0])
        // eslint-disable-next-line
        if (cb) cb(true)
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
        // eslint-disable-next-line
        if (cb) cb(false)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Profile Update failed! Please try again later. ')
      closeNotice(commit, 20000)
      // eslint-disable-next-line
      if (cb) cb(false)
    })
  },
  logout ({ commit }) {
    ssoApi.putData('user/logout')
    .then(res => {
      commit('logout')
    })
    .catch(err => {
      console.log('logout failed')
      console.log(err)
      commit('logout')
    })
  },
  getUserProfileInformation ({ commit }) {
    tapApi.getData('user/user')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        const user = res.data.data[0]
        commit('setKyc', {
          pan: user.pan,
          aadhar: user.aadhar
        })
        commit('setUser', user.user)
        Store.dispatch('user/viewProfilePicture')
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
    })
  },
  saveUserProfileInformation ({ commit }, userDto) {
    tapApi.putData('user/user', userDto)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        const user = res.data.data[0]
        commit('setKyc', {
          pan: user.pan,
          aadhar: user.aadhar
        })
        commit('setUser', user.user)
        Store.dispatch('user/viewProfilePicture')
        sendSuccessNotice(commit, 'Profile Information has been updated.')
        closeNotice(commit, 1500)
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
    })
  },
  getKyc ({ commit }) {
    tapApi.getData('user/kycforonboard')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        const kyc = res.data.data[0]
        commit('setKyc', {
          pan: kyc.pan,
          aadhar: kyc.aadhar
        })
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
    })
  },
  getDashboard ({ commit }) {
    tapApi.getData('algo/dashboard')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setDashboard', res.data.data[0])
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Dashboard loading failed! Please try again later. ')
      closeNotice(commit, 20000)
    })
  }
}

const mutations = {
  loginLoading (state) {
    state.callingAPI = !state.callingAPI
  },
  globalSearching (state) {
    state.searching = state.searching === '' ? 'loading' : ''
  },
  setCompletion (state, completion) {
    state.completion = completion
  },
  setProfilePictureSrc (state, src) {
    state.profilePictureSrc = src
  },
  setUser (state, user) {
    state.user = user
  },
  setToken (state, token) {
    state.token = token
  },
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  setProfilePic (state, profilePic) {
    state.profilePic = profilePic
  },
  setKyc (state, kyc) {
    if (kyc.pan !== null) state.kyc.pan = kyc.pan
    if (kyc.aadhar !== null) state.kyc.aadhar = kyc.aadhar
  },
  setLoading (state, value) {
    state.loading = value
  },
  logout (state) {
    state.user = new User()
    state.completion = 0
    state.kyc.pan = new Kyc('PAN')
    state.kyc.aadhar = new Kyc('AADHAR')
    state.profilePictureSrc = ''
    state.dashboard = new Dashboard()
    state.token = ''
    state.loading = false
    Router.push('/login')
  },
  setDashboard (state, dashboard) {
    state.dashboard = dashboard
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js